<template>
  <div class="quote-review p-24 flex-col">
    <div class="flex-align__between">
      <a-input-search
        style="width: 300px"
        placeholder="请输入投标单位名称"
        enter-button
        class="m-r-24"
        @search="handleSearch"
      />
      <el-button v-if="!isReviewClose" type="primary" plain @click="stopReview">
        终止评审
      </el-button>
    </div>

    <el-scrollbar class="m-t-24 scrollbar-y-hidden">
      <el-table :data="tableData" border>
        <el-table-column label="序号" type="index" width="60" align="center" />
        <el-table-column
          v-for="head in tableHead"
          :key="head.label"
          :label="head.label"
          align="center"
        >
          <template v-slot:default="{ row }">
            <span>
              {{ getTdContent(head, row).content }}
            </span>
            <money-in-cn
              v-if="tdIsMoney(head)"
              :money="getTdContent(head, row).content"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template v-slot:default="{ row }">
            <div class="flex row-center">
              <upload-authorization-file
                :attachment-group-id="getFileIds(row)"
                :download-api="getReviewQuoteFileApi"
                :preview-api="getReviewQuoteFileApi"
                :request-params="{
                  reviewId,
                  orderId,
                  supplierId: row.supplierId,
                  fileType: fileType
                }"
                upload-mode="fileId"
                :props-data="{
                  disabled: true,
                  fileListHiddenControl: {
                    hiddenFileName: true,
                    hiddenDownloadBtn: true,
                    hiddenPreviewBtn: false,
                    previewBtnText: '报价文件'
                  }
                }"
              />

              <el-button
                class="m-l-16"
                type="text"
                @click="openNoRateQuoteDialog(row)"
              >
                未含税价明细
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-scrollbar>

    <div v-if="showFoot" class="summary-foot">
      <el-button type="primary" @click="confirmSummary">
        确认报价无误
      </el-button>
      <el-button
        v-if="purchaseType === purchaseTypeDict.INQUIRY.value"
        type="primary"
        @click="toOpenRound"
      >
        发起多轮报价
      </el-button>
      <el-button
        v-if="purchaseType === purchaseTypeDict.NEGOTIATION.value"
        type="primary"
        @click="jumpNegotiate"
      >
        开启多次谈判
      </el-button>
    </div>

    <!-- 报价文件查看 -->
    <file-preview v-model="showSignOfferFile" :file-url="offerFileUrl" />

    <material-no-rate-quote-detail-dialog
      ref="noRateQuoteDialog"
      :review-id="reviewId"
      :order-id="orderId"
      :bidder="currentBidder"
      :purchase-type="purchaseType"
      :offer-unit="offerUnit"
    />
  </div>
</template>

<script>
import FilePreview from '@/components/common/Upload/FilePreview.vue'
import UploadAuthorizationFile from '@/components/common/Upload/UploadAuthorizationFile.vue'
import MoneyInCn from '@/components/common/MoneyInCn.vue'
import MaterialNoRateQuoteDetailDialog from '@/components/online-review/review/MaterialNoRateQuoteDetailDialog.vue'
import { currencyTypeDict } from '@/dictionary/project/common'
import { inquiryReviewTypeDict } from '@/dictionary/project/online-review'
import {
  getInquiryReviewQuoteFileApi,
  getInquiryReviewScorePageApi
} from '@/api/procure/inquiry-review'
import { workbenchServiceDict } from '@/dictionary/system'
import { reviewWayStatusDict } from '@/dictionary/hall/review-hall'
import {
  submitPurchaseReviewByQuoteSummaryApi,
  stopPurchaseReviewApi
} from '@/api/procure/purchase-review'

import { purchaseTypeDict } from '@/dictionary/project/common'
/** *****谈判采购******* */
import {
  getNegotiationReviewScorePageApi,
  getNegotiationReviewQuoteFileApi,
  submitNegotiationReviewByQuoteSummaryApi
} from '@/api/procure/negotiation-review'
import { inquiryReviewFileTypeDict } from '@/dictionary/project/inquiry'
export default {
  name: 'OnlineReviewByQuote',

  components: {
    FilePreview,
    UploadAuthorizationFile,
    MoneyInCn,
    MaterialNoRateQuoteDetailDialog
  },

  props: {
    reviewId: {
      type: [String, Number],
      default: ''
    },

    orderId: {
      type: [String, Number],
      default: ''
    },

    roundId: {
      type: [String, Number],
      default: ''
    },

    reviewWay: {
      type: Object,
      default: () => {}
    },

    // 报价单位
    offerUnit: {
      type: String,
      default: currencyTypeDict.YUAN.label
    },

    reviewerList: {
      type: Array,
      default: () => []
    },

    purchaseType: {
      type: [Number, String],
      default: purchaseTypeDict.INQUIRY.value
    },

    // 是否终止评审
    isReviewClose: {
      type: Boolean,
      default: false
    },

    // 报价文件类型
    fileType: {
      type: [String, Number],
      default: inquiryReviewFileTypeDict.OFFER_ATTACHMENT.value
    },

    // 报价是否含税
    offerRequireTax: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      purchaseTypeDict,

      tableHeadMap: {},
      tableData: [],
      // 列表筛选表单
      filterForm: {
        // 报价单位名称
        supplierName: ''
      },

      showSignOfferFile: false,
      offerFileUrl: '',

      currentBidder: {}
    }
  },

  computed: {
    tableHead() {
      return [
        { label: '报价单位', prop: 'supplierName' },
        { label: `报价总金额（${this.offerUnit}）`, prop: 'offerPrice' },
        this.offerRequireTax
          ? { label: `未含税价（${this.offerUnit}）`, prop: 'noRateOfferPrice' }
          : null
      ].filter(value => value)
    },

    // 代理机构加上Agency
    entrustRouter() {
      if (this.currentWorkbench === workbenchServiceDict.AGENCY.value) {
        return 'Agency'
      }
      return ''
    },

    showFoot() {
      // 当前评审办法已汇总，则不显示
      return this.reviewWay.summaryStatus !== reviewWayStatusDict.SUMMARY.value
    },

    getReviewQuoteFileApi() {
      const obj = {
        [purchaseTypeDict.INQUIRY.value]: getInquiryReviewQuoteFileApi,
        [purchaseTypeDict.NEGOTIATION.value]: getNegotiationReviewQuoteFileApi
      }
      return obj[this.purchaseType]
    }
  },

  watch: {
    reviewWay: {
      handler(val) {
        if (
          val?.wayId &&
          val.wayType === inquiryReviewTypeDict.QUOTATION.value
        ) {
          this.getTableData()
        }
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    handleSearch(value) {
      this.filterForm.supplierName = value
      this.getTableData()
    },

    getTableData() {
      const params = {
        isListing: 1,
        orderId: this.orderId,
        wayId: this.reviewWay.wayId,
        reviewerId: this.reviewerList[0]?.reviewerId,
        ...this.filterForm
      }
      const obj = {
        [purchaseTypeDict.INQUIRY.value]: getInquiryReviewScorePageApi,
        [purchaseTypeDict.NEGOTIATION.value]: getNegotiationReviewScorePageApi
      }
      obj[this.purchaseType](this.reviewId, params)
        .then(res => {
          this.tableData = res.data?.records || []
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    tdIsMoney(head) {
      return head.label.includes('金额') || head.label.includes('含税价')
    },

    getTdContent(head, row) {
      if (head.prop) {
        return { content: row[head.prop] || '-' }
      }
      return '-'
    },

    confirmSummary() {
      if (this.isReviewClose) {
        this.$message.warning('该评审已终止，操作失败')
        return
      }
      this.$systemConfirm('确定提交汇总吗？').then(() => {
        const objApi = {
          [purchaseTypeDict.INQUIRY
            .value]: submitPurchaseReviewByQuoteSummaryApi,
          [purchaseTypeDict.NEGOTIATION
            .value]: submitNegotiationReviewByQuoteSummaryApi
        }
        objApi[this.purchaseType](this.reviewId, {
          wayId: this.reviewWay.wayId,
          orderId: this.orderId
        })
          .then(res => {
            this.$emit('afterSummary')
          })
          .catch(err => {
            if (err?.message) this.$message.error(err.message)
          })
      })
    },

    /**
     * 跳转询比发起多轮报价页面
     */
    toOpenRound() {
      if (this.isReviewClose) {
        this.$message.warning('该评审已终止，操作失败')
        return
      }
      const params = {
        orderId: this.orderId,
        roundId: this.roundId
      }

      this.$router.push({
        name: this.entrustRouter + 'InquiryMultipleRounds',
        params,
        query: {
          from: 'ReviewHall'
        }
      })
    },

    getFileIds(row) {
      return JSON.parse(row.offerFileIds || '')
    },

    /**
     * 跳转到多次谈判页面
     */
    jumpNegotiate() {
      if (this.isReviewClose) {
        this.$message.warning('该评审已终止，操作失败')
        return
      }
      this.$router.push({
        name: this.entrustRouter + 'NegotiationRoundNegotiate',
        params: {
          orderId: this.orderId
        },
        query: {
          from: 'ReviewHall'
        }
      })
    },

    /**
     * 终止评审
     */
    async stopReview() {
      await this.$confirm('评审后评标报告只展示已汇总的评审内容', '提示', {
        type: 'warning',
        confirmButtonText: '确认终止'
      })
      try {
        await stopPurchaseReviewApi(this.reviewId)
        this.$message.success('终止评审成功')
        this.$emit('afterSummary')
      } catch (error) {
        this.$message.error(error?.message)
      }
    },

    openNoRateQuoteDialog(row) {
      this.currentBidder = row
      this.$refs.noRateQuoteDialog.openDialog()
    }
  }
}
</script>

<style scoped lang="scss">
.quote-review {
  height: 100%;

  //::v-deep .file-list {
  //  text-align: center;
  //  display: flex;
  //  row-between: true;
  //
  //  .file-operate {
  //    margin: 0;
  //  }
  //}
}
.summary-foot {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: $white-color;
  box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.06);
  border: 1px solid $info-fifth-color;
  height: 56px;
  text-align: center;
  padding: 12px 0;
}
</style>
